import { render, staticRenderFns } from "./ErrorConnection.vue?vue&type=template&id=0af391a2&scoped=true"
import script from "./ErrorConnection.vue?vue&type=script&lang=ts"
export * from "./ErrorConnection.vue?vue&type=script&lang=ts"
import style0 from "./ErrorConnection.vue?vue&type=style&index=0&id=0af391a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af391a2",
  null
  
)

export default component.exports